import "./App.css";
import { Navbar } from "./component/Navbar";
import { Home } from "./component/Home";
import { About } from "./component/About";
import { Contact } from "./component/Contact";
import { Project } from "./component/Project";
import { Skills } from "./component/skills";
import { Skills1 } from "./component/skills1";
function App() {
  return (
    <div className="App">
      <Navbar />
      <Home />
      <About />
      <Skills />
      <Skills1 />
      <Project />
      <Contact />
    </div>
  );
}

export default App;
